<div class="row mt-4 pb-4">
  <div class="col-6">
    @if (controls?.prev; as control) {
      <button (click)="prev()"
        [disabled]="pending"
        class="btn  btn-secondary">
        <em class="fas {{ control.icon }} "></em> {{ control.label | translate }}
      </button>
    }
  </div>
  <div class="col-6 text-right">
    @if (controls?.next; as control) {
      <button (click)="next()"
        [disabled]="disabled || pending"
        class="btn  btn-secondary ">
        {{ control.label | translate }} <em class="fas {{ control.icon }}"></em>
      </button>
    }
  </div>
</div>
